import { useGetCreditMemoApplicationResponseQuery } from '../../__generated__/chirp/com/hubspot/invoices/rpc/ApplyingCreditMemosToInvoicesService.hooks';
export const useGetAppliedCreditMemos = ({
  invoiceId,
  skip = false
}) => {
  const {
    data: appliedCreditMemosData,
    loading: appliedCreditMemosLoading
  } = useGetCreditMemoApplicationResponseQuery({
    variables: {
      invoiceId: Number(invoiceId)
    },
    skip: skip || !invoiceId
  });
  return {
    appliedCreditMemos: appliedCreditMemosData === null || appliedCreditMemosData === void 0 ? void 0 : appliedCreditMemosData.creditMemoApplicationDetails,
    appliedCreditMemosLoading
  };
};